import React, { Component } from 'react';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Input from '../Input';
import Row from '../Row';
import Textarea from '../Textarea';
import Toast from '../Toast/Toast';
import Select from '../Select';
import { selectFndFormData } from '../../store/selectors/fndForm';
import { setFndFormData, clearFndFormData } from '../../store/actions/fndForm'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectUserProfileDetails } from '../../store/selectors/settings';
import File from '../File';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import FontAwesomeIcon from '../Icon';
import { stopFormLoading } from '../../store/actions/loader';
import { onCheckDocument, onCheckHeicDocument } from '../../helpers/CommonHelpers';

class CommonIssueForm extends Component {
  state = {
    buttonPressed: '',
    showOverlay:false
  };
  componentDidMount () {
    this.props.stopFormLoading();
  }
  componentDidUpdate () {
    const { validation, onClose, clearFndFormData, clearValidation } = this.props;
    if(validation.status === true) {
      if(validation.message === 'Success' && this.state.buttonPressed === 'SaveAndClose') {
        onClose();
        clearFndFormData();
        clearValidation();
      } else if(validation.message === 'Success' && this.state.buttonPressed === 'SaveAndAdd') {
        clearFndFormData();
        clearValidation();
      }
    }
  }

  buttonDisabled(){
    const { fndForm } = this.props;
      return !fndForm.description || !fndForm.issueTypeId
  }

  selectMultipleItems = (files) => {
    const { setFndFormData, fndForm } = this.props;
    if (fndForm.attachment && fndForm.attachment.length) {
      let attachment = fndForm.attachment
      for (var i = 0; i < attachment.length; i++) {
        if (attachment[i].id) {
        } else {
          for (var j = 0; j < files.length; j++) {
            if (files[j].name === attachment[i].name) {
              files.splice(j, 1)

            }
          }
        }

      }
      setFndFormData({ attachment: [...files, ...attachment] })
      } else {
        setFndFormData({ attachment: files })
    }
  }

  handleDelete(item, i) {

    const { setFndFormData, fndForm } = this.props;
    let attachment = fndForm.attachment;
    if(item.url) {
      attachment = fndForm.attachment.filter(data => (data.url !== item.url))
    } else {
      attachment = fndForm.attachment.filter(data => (data.path !== item.path))
    }

    setFndFormData({ attachment:attachment })
  }

  render() {
    const { onClose, types, onSaveCommonIssue, breadcrumb,fndForm, setFndFormData,user, loader } = this.props;
    
    return (
      <Form
        headline={(fndForm.id ? "Edit":"Add") + " a Common Issue"}
        onClose={() => onClose()}
        onSubmit={() => onSaveCommonIssue(fndForm, this.state.buttonPressed)}
        actions={(
          <>
            {loader ? <Loader center={true}/> : null}
            { fndForm.id ? <div/> : <Button
              color="semantic"
              size="small"
              label="Save and Add Another"
              onClick={()=> this.setState({
                buttonPressed:'SaveAndAdd'
              })}
              disabled={ this.buttonDisabled()}
            />}
            <Button
              color="teal"
              size="small"
              label="Save Common Issue"
              onClick={()=> this.setState({
                buttonPressed:'SaveAndClose'
              })}
              disabled={ this.buttonDisabled()}
            />
          </>
        )}
        component={(
          <>
            <Row mdCenter>
              <Col
                xs="12"
                md="6"
              >
                {breadcrumb && (
                  <>
                    <Toast
                      message={(
                        <>
                          You are adding a common issue to <strong>{breadcrumb}</strong>.
                        </>
                      )}
                    />
                    <br />
                    <br />
                  </>
                )}
                 <Select
                    value={fndForm && fndForm.issueTypeId ? fndForm.issueTypeId : ''}
                    onChange={e => setFndFormData({ issueTypeId: e.target.value})}
                    options={types.length > 0 ? types.map(item => ({ label: item.name, value: item.id })) : [{ label: 'No Issue Types', value: 'id' }]}
                    label="Issue Type"
                    placeholder="Select Issue Type"
                    block
                />
                <Textarea
                  required
                  value={fndForm.description}
                  onChange={e => setFndFormData({ description: e.target.value })}
                  label="Description"
                  placeholder="Description"
                  block
                />
                <File
                    label="Attachment"
                    onSelect={(file) => onCheckHeicDocument(file) && this.selectMultipleItems(file)}
                    files={[]}
                    multiSelect={true}
                    type='image'

                />
            {fndForm.attachment && fndForm.attachment.length > 0 ?
                fndForm.attachment.map((data, i) => (

                    <Row >
                        <Col
                            granola

                            xs="12"
                            md="9"
                        >
                            {data && data.path ? data.path : data.title}
                        </Col>

                        <Col granola xs='12' md='3'>
                            <div onClick={() => this.handleDelete(data, i)}>
                                <FontAwesomeIcon
                                    glyph="times-circle"
                                    weight="light"
                                    size="small"
                                />
                            </div>
                        </Col>
                    </Row>
                )
                ) : null}

              </Col>
            </Row>
          </>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  user:selectAuthenticatedUser(state),
  fndForm: selectFndFormData(state),
  settings:selectUserProfileDetails(state),
  loader: selectFormLoader(state),
  validation: selectValidation(state),
})


const mapDispatchToProps = dispatch => bindActionCreators({
  setFndFormData,
  clearFndFormData,
  clearValidation: clearValidation,
  stopFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommonIssueForm);

